export const required = value => (value ? undefined : 'This field is required.')



// WEBPACK FOOTER //
// ../source/utilities/validators.js